<template>
  <div>
    <v-menu bottom left>
      <v-btn slot="activator" outline primary>
        {{ $t('usermenu.actions') }}
        <v-icon class="primary--text ml-2">keyboard_arrow_down</v-icon>
      </v-btn>
      <v-list>
        <v-list-item v-if="selected.length">
          <v-list-tile @click.native="chatPopup = true">
            <v-list-tile-title>{{ $t('usermenu.send') }}</v-list-tile-title>
          </v-list-tile>
        </v-list-item>
        <v-list-item v-else>
          <v-list-tile @click.native="chatAllPopup = true">
            <v-list-tile-title>{{ $t('usermenu.sendToAll') }}</v-list-tile-title>
          </v-list-tile>
        </v-list-item>
        <v-list-item>
          <v-list-tile @click.native="userFormPopup = true">
            <v-list-tile-title>{{ $t('usermenu.addUser') }}</v-list-tile-title>
          </v-list-tile>
        </v-list-item>
        <v-list-item>
          <v-list-tile @click.native="exportUsers">
            <v-list-tile-title>{{ $t('usermenu.export') }}</v-list-tile-title>
          </v-list-tile>
        </v-list-item>
        <v-list-item>
          <v-list-tile @click.native="userImportPopup = true">
            <v-list-tile-title>{{ $t('usermenu.import') }}</v-list-tile-title>
          </v-list-tile>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog width="640px" v-model="chatPopup">
      <v-card>
        <v-card-title>{{ $t('usermenu.send') }}</v-card-title>
        <v-divider></v-divider>
        <message-form :user="chatUsers" :redirect="false"></message-form>
      </v-card>
    </v-dialog>
    <v-dialog width="640px" v-model="chatAllPopup">
      <v-card>
        <v-card-title>{{ $t('usermenu.sendToAll') }}</v-card-title>
        <v-divider></v-divider>
        <message-form :user="'all'" :redirect="false"></message-form>
      </v-card>
    </v-dialog>
    <v-dialog width="640px" v-model="userFormPopup">
      <v-card>
        <v-card-title>{{ $t('usermenu.addUser') }}</v-card-title>
        <v-divider></v-divider>
        <user-form @created="onUserAdded"></user-form>
      </v-card>
    </v-dialog>
    <v-dialog width="640px" v-model="userImportPopup">
      <v-card>
        <v-card-title>{{ $t('usermenu.import') }}</v-card-title>
        <v-divider></v-divider>
        <import-form @imported="userImportPopup = false"></import-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import User from '@/api/user'
  import MessageForm from '@/components/messenger/MessageForm.vue'
  import UserForm from '@/components/user/Form.vue'
  import ImportForm from '@/components/user/ImportForm.vue'
  export default {
    components: {
      MessageForm,
      UserForm,
      ImportForm
    },
    props: {
      selected: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        chatPopup: false,
        chatAllPopup: false,
        userFormPopup: false,
        userImportPopup: false
      }
    },
    computed: {
      chatUsers () {
        return this.selected.map(e => ({
          _id: e.chatable_id,
          name: e.nickname
        }))
      }
    },
    methods: {
      async exportUsers () {
        await User.exportUsers()
        alert(this.$t('usermenu.exportStarted'))
      },
      onUserAdded (user) {
        this.userFormPopup = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UsersMenu.vue